<template>
	<div style="width: 100vw;">
		<div v-if="transactions.length > 0" class="limit-width">
			<table class="table transactions encore-background limit-width" >
				<!-- <tr>
					<th>{{ languageStrings.casinoId }}</th>
					<td>{{ item.casinoId }}</td>
				</tr> -->
				<table class="transactions second-table-container limit-width" >
					<thead>
						<tr class="header-row" style="color: white !important;">
							<th>{{ languageStrings.fromPlayerCash }}</th>
							<th>{{ languageStrings.initiationDate }}</th>
							<!-- <td>{{ systemCurrencyTool.formatCurrency(item.fromPlayerCashCOC, systemCurrencyTool.displayType.minorOrFull) }}</td> -->
						</tr>
					</thead>
					<tbody class="limit-width" v-for="(item, index) in transactions" :class="checkForExpandedRows(index) ? 'selected' : expandedRows.length == 0 ? 'selected' : 'not-selected'" :key="index" @click="openDetails(index)">
						<tr :id="index" class="limit-width">
							<td v-if="item.fromPlayerCashCOC >= 0">
								{{
									systemCurrencyTool.formatCurrency(
										item.fromPlayerCashCOC,
										systemCurrencyTool.displayType.minorOrFull
									)
								}}
							</td>
							<td v-else class="negative-value">
								{{
									systemCurrencyTool.formatCurrency(
										item.fromPlayerCashCOC,
										systemCurrencyTool.displayType.minorOrFull
									)
								}}
							</td>
							<td v-if="item.initiationDate" class="nowrap-text right-padding-for-start-date">
								{{ new Date(item.initiationDate).toLocaleTimeString(this.localeString, dateOptions) }}
							
							<i v-if="checkForExpandedRows(index)" class="arrow up"></i>
							<i v-else class="arrow down"></i>
						</td>
							<td v-else></td>
						</tr>
						<tr v-if="checkForExpandedRows(index)" class="panel limit-width">
							<td colspan="2" class="limit-width">
								<table class="limit-width">
									<thead class="limit-width">
										<th class="curved-border second-table-table-header-colors">{{ languageStrings.status }}</th>
										<th class="second-table-table-header-colors">{{ languageStrings.offerExpirationDate }}</th>
										<th class="second-table-table-header-colors">{{ languageStrings.provider }}</th>
										<th class="curved-border second-table-table-header-colors" style="text-wrap: wrap;">{{ languageStrings.statusAdditionalInfo }}</th>
									</thead>
									<td class="expandable-data status-text" v-if="item.status === 'Committed'">{{ languageStrings.committed }}</td>
									<td class="expandable-data status-text" v-else-if="item.status === 'Cancelled'" >{{ languageStrings.cancelled }}</td>
									<td class="expandable-data status-text" v-else-if="item.status === 'Expired'" >{{ languageStrings.expired }}</td>
									<td class="expandable-data status-text" v-else-if="item.status === 'OfferedToUser'" >{{ languageStrings.offeredToUser }}</td>
									<td class="expandable-data status-text" v-else-if="item.status === 'WaitingForProviderConfirmation'" >{{ languageStrings.waitingForProviderConfirmation }}</td>
									<td class="expandable-data status-text" v-else-if="item.status === 'RefusedByProvider'" >{{ languageStrings.refusedByProvider }}</td>
									<td v-if="item.offerExpirationDate" class="expandable-data bottom-padding-for-exp-date">
										{{
											new Date(item.offerExpirationDate).toLocaleTimeString(
												this.localeString,
												dateOptions
											)
										}}
									</td>
									<td v-else></td>
									<td class="expandable-data">{{ item.provider }}</td>
									<!-- <td>{{ item.statusAdditionalInfo }}</td> -->
									<button class="btn" @click="showDetails(item)">{{ languageStrings.view }}</button>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</table>
			<transition name="fade">
				<component v-bind:is="currentModal" :selectedTransaction="selectedTransaction" :systemCurrencyTool="systemCurrencyTool" :languageStrings="languageStrings"/>
			</transition>
		</div>
		<h2 v-else>{{ languageStrings.noTransactionsFound }}</h2>
	</div>
</template>

<script>
import sharedScripts from "../dependencies/sharedScripts";
import TransactionHistoryAdditionalInformation from "./TransactionHistoryAdditionalInformation.vue";
import router from "@/router";

export default {
	name: "TransactionsTableMobile",
	components: {
		TransactionHistoryAdditionalInformation
	},
	props: {
		systemCurrencyTool: Object,
		systemSettings: Object,
		transactions: Array,
		languageStrings: Object,
	},
	data() {
		return {
			expandedRows: [],
			currentModal: null,
			selectedTransaction: null
		};
	},
	watch: {
		transactions() {
			this.expandedRows= [];
		}
	},
	created() {
		this.eventBus.on("closeModal", () =>{
			this.currentModal = null;
		});
	},
	methods: {
		openDetails(index) {
			document.getElementById(index).addEventListener("click", this.open(index));
		},

		open(index) {
			sharedScripts.openRowDetails(this.expandedRows, index);
		},

		checkForExpandedRows(index) {
			return this.expandedRows.includes(index);
		},
		showDetails(transaction) {
			this.selectedTransaction = transaction;
			this.currentModal = "TransactionHistoryAdditionalInformation";
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
tr.header-row {
	position: sticky;
	top: 0;
	background-color: #6305C9 !important;
	color: #fff !important;
	border-bottom: 1px solid rgb(123, 123, 123);
	white-space: break-spaces;
}

h1,
h2,
h3 {
	text-align: center;
}

.transactions {
	position: relative;
	width: 100%;
	/* margin: 0 auto 30px; */
	border-collapse: separate;
	text-align: center;
	box-sizing: border-box;
	border-spacing: 0 0.7em;
}

.transactions th {
	/*background-color: black; */
	color:  white;
	padding: 3px;
	width: 50%;
}

.transactions tr {
	transition: background-color 0.3s;
}

.transactions tbody {
	background-color: white;
	color: #6305c9;
}

button.btn {
	display: block;
}

td::first-letter {
	text-transform: capitalize;
}

tr td:first-of-type {
	border-top-left-radius: 15px;
	border-bottom-left-radius: 15px;
}

tr td:last-of-type {
	border-top-right-radius: 15px;
	border-bottom-right-radius: 15px;
}
tr {
	padding: 10px;
	font-weight: bold;
}

.expandable-data {
	color: #6305c9;
}

.second-table-container {
	/* width: 96%; */
}

.limit-width {
	max-width: 100vw;
}

.panel {
	background-color: white;
	color: #6305c9;
}

.second-table-table-header-colors {
	background-color: white !important;
	color: #6305c9 !important;
}

.status-text {
	/* line-break: anywhere; */
	font-size: 13px;
}

.small-font {
	/* font-size: 14px; */
}

.bottom-padding-for-exp-date {
	padding-bottom: 20px;
}
.right-padding-for-start-date {
	padding-right: 10px;
}

.down {
	margin-left: 5px;
}

@media (max-width: 767px) and (min-width: 521px) {
	tbody {
		line-height: 4vh;
	}

	.nowrap-text {
		text-wrap: nowrap;
	}

	.wrap-text {
		line-break: anywhere;
	}
}
</style>
